import { render, staticRenderFns } from "./ProjectGuestInvitation.vue?vue&type=template&id=6f39894e&scoped=true"
import script from "./ProjectGuestInvitation.vue?vue&type=script&lang=ts"
export * from "./ProjectGuestInvitation.vue?vue&type=script&lang=ts"
import style0 from "./ProjectGuestInvitation.vue?vue&type=style&index=0&id=6f39894e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39894e",
  null
  
)

export default component.exports